import { Text, Title } from './styles'

export const Typography = {
  Title,
  Text,
}
